import {
    ADD_COURSE_ERROR,
    ADD_COURSE_SUCCESS
    } from "../../actionTypes/authActionTypes";
    
    const reducer = (state = {}, action) => {
      switch (action.type) {
        case ADD_COURSE_SUCCESS:
          return {
            ...state,
            newCourseData: action.payload,
          };
        case ADD_COURSE_ERROR:
          return {
            ...state,
            newCourseError: action.payload,
          };
        default:
          return state;
      }
    };
    
    export default reducer;
    